import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Package, Clock, Truck, ListOrdered } from "lucide-react";
import { OrdersStats as OrdersStatsType } from "@/hooks/useOrders";

interface OrdersStatsProps {
  stats: OrdersStatsType | undefined;
  isLoading: boolean;
}

const OrdersStats = ({ stats, isLoading }: OrdersStatsProps) => {
  const statCards = [
    {
      title: "Wachtend op Verzending",
      value: stats?.awaitingShipment || 0,
      icon: Truck,
      color: "text-orange-500",
      bgColor: "bg-orange-50",
    },
    {
      title: "Vandaag Toegevoegd",
      value: stats?.todayOrders || 0,
      icon: Clock,
      color: "text-blue-500",
      bgColor: "bg-blue-50",
    },
    {
      title: "Totaal Openstaand",
      value: stats?.totalOrders || 0,
      icon: Package,
      color: "text-green-500",
      bgColor: "bg-green-50",
    },
    {
      title: "Orderregels",
      value: stats?.totalLines || 0,
      icon: ListOrdered,
      color: "text-purple-500",
      bgColor: "bg-purple-50",
    },
  ];

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(4)].map((_, i) => (
          <Card key={i}>
            <CardContent className="p-4">
              <Skeleton className="h-4 w-24 mb-2" />
              <Skeleton className="h-8 w-16" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {statCards.map((stat) => (
        <Card key={stat.title}>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">{stat.title}</p>
                <p className="text-2xl font-bold">{stat.value}</p>
              </div>
              <div className={`p-3 rounded-full ${stat.bgColor}`}>
                <stat.icon className={`h-5 w-5 ${stat.color}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default OrdersStats;
